import { render, staticRenderFns } from "./terminalmanage.vue?vue&type=template&id=4e8c0e28&scoped=true"
import script from "./terminalmanage.vue?vue&type=script&lang=js"
export * from "./terminalmanage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8c0e28",
  null
  
)

export default component.exports